// Single source of truth for property marker colors. The meaning of each
// color is a per-CID label stored positionally in cids.legend[legendIndex].
// Value strings are stored in properties.flag_color (VarChar(10) — keep names
// short) and validated server-side in propertyRoute's bulkUpdate.
export const MARKER_OPTIONS = [
  { value: "blue", color: "#1976d2", legendIndex: 0, fallback: "Blue Marker" },
  { value: "red", color: "#d32f2f", legendIndex: 1, fallback: "Red Marker" },
  { value: "green", color: "#2e7d32", legendIndex: 2, fallback: "Green Marker" },
  { value: "orange", color: "#ef6c00", legendIndex: 3, fallback: "Orange Marker" },
  { value: "purple", color: "#7b1fa2", legendIndex: 4, fallback: "Purple Marker" },
  { value: "teal", color: "#00838f", legendIndex: 5, fallback: "Teal Marker" },
  { value: "pink", color: "#c2185b", legendIndex: 6, fallback: "Pink Marker" },
];

export const NO_MARKER_COLOR = "#9e9e9e";

// Resolves display labels from a CID's legend array, falling back to color names.
export const markerOptionsWithLabels = (legend = []) =>
  MARKER_OPTIONS.map((option) => {
    const label = legend[option.legendIndex];
    return {
      ...option,
      label: label && label.trim().length > 0 ? label : option.fallback,
    };
  });
